'use strict';

var auth = require('@tarslib/types/lib/auth');
function isAuthInherit(obj) {
  if (!obj) return true;
  if (obj && obj.type === auth.AuthValue.InHerit) return true;
  return Object.keys(obj).length === 0;
}
exports.isAuthInherit = isAuthInherit;
